export enum NightAnalysisActionValues {
    Validation = "Validation",
    Interpretation = "Interpretation",
    Signature = "Signature",
}
